import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"ma-0 pa-0 d-flex justify-center",attrs:{"fluid":""}},[_c(VContainer,{staticClass:"ma-0 pa-0"},[_c(VTabs,{staticClass:"d-md-none mb-6",attrs:{"fixed-tabs":""},model:{value:(_vm.tabs_meldenHistorie),callback:function ($$v) {_vm.tabs_meldenHistorie=$$v},expression:"tabs_meldenHistorie"}},[_c(VTab,[_vm._v("Melden")]),_c(VTab,[_vm._v("Historie")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }